/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cleared_The_14day_EscrowInputs */

const en_cleared_the_14day_escrow = /** @type {(inputs: Cleared_The_14day_EscrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cleared the 14-day escrow`)
};

const es_cleared_the_14day_escrow = /** @type {(inputs: Cleared_The_14day_EscrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Superó los 14 días de custodia`)
};

const fr_cleared_the_14day_escrow = /** @type {(inputs: Cleared_The_14day_EscrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Période d'entiercement de 14 jours terminée`)
};

const de_cleared_the_14day_escrow = /** @type {(inputs: Cleared_The_14day_EscrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`14-tägige Treuhandfrist abgelaufen`)
};

const ja_cleared_the_14day_escrow = /** @type {(inputs: Cleared_The_14day_EscrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`14日間のエスクローをクリア`)
};

const zh_cleared_the_14day_escrow = /** @type {(inputs: Cleared_The_14day_EscrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`已过 14 天担保期`)
};

const ar_cleared_the_14day_escrow = /** @type {(inputs: Cleared_The_14day_EscrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تجاوز فترة ضمان 14 يوماً`)
};

const id_cleared_the_14day_escrow = /** @type {(inputs: Cleared_The_14day_EscrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Melewati escrow 14 hari`)
};

const it_cleared_the_14day_escrow = /** @type {(inputs: Cleared_The_14day_EscrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Superato il periodo di deposito in garanzia (escrow) di 14 giorni`)
};

const ru_cleared_the_14day_escrow = /** @type {(inputs: Cleared_The_14day_EscrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Прошло 14 дней эскроу`)
};

const pt_cleared_the_14day_escrow = /** @type {(inputs: Cleared_The_14day_EscrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Passou os 14 dias de escrow`)
};

const ko_cleared_the_14day_escrow = /** @type {(inputs: Cleared_The_14day_EscrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`14일 에스크로 기간 통과됨`)
};

/**
* | output |
* | --- |
* | "Cleared the 14-day escrow" |
*
* @param {Cleared_The_14day_EscrowInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const cleared_the_14day_escrow = /** @type {((inputs?: Cleared_The_14day_EscrowInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cleared_The_14day_EscrowInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_cleared_the_14day_escrow(inputs)
	if (locale === "es") return es_cleared_the_14day_escrow(inputs)
	if (locale === "fr") return fr_cleared_the_14day_escrow(inputs)
	if (locale === "de") return de_cleared_the_14day_escrow(inputs)
	if (locale === "ja") return ja_cleared_the_14day_escrow(inputs)
	if (locale === "zh") return zh_cleared_the_14day_escrow(inputs)
	if (locale === "ar") return ar_cleared_the_14day_escrow(inputs)
	if (locale === "id") return id_cleared_the_14day_escrow(inputs)
	if (locale === "it") return it_cleared_the_14day_escrow(inputs)
	if (locale === "ru") return ru_cleared_the_14day_escrow(inputs)
	if (locale === "pt") return pt_cleared_the_14day_escrow(inputs)
	return ko_cleared_the_14day_escrow(inputs)
});